export const randomNumber = () => {
  return Math.random();
};
